module.exports = __webpack_public_path__ + "img/hand.e8fdcb18.svg";